import React, { Component } from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import UserFilterSectionDropdown from '../UserFilterSectionDropdown';
import CommonMenu from '../Menu/CommonMenu';
// utils
import isEqual from 'lodash.isequal';
import { formatOptionsValues, getConditionTranslationsBySection } from 'utils/userFiltersHelper';

class CommonSection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: '',
      value: props.condition,
      ...formatOptionsValues(props.options)
    };
  }

  handleConditionChange = ({ target: { name } }) => {
    this.setState({ value: name, text: '' });
  };

  handleInputChange = ({ target: { value } }) => {
    this.setState({ text: value });
  };

  handleApply = () => {
    const { onOptionSelect } = this.props;
    const { value, text } = this.state;
    if (value === 'any') {
      onOptionSelect(value);
      return;
    }
    onOptionSelect(value, [{ key: 'text', value: text }]);
  };

  resetData = () => {
    const { condition, options } = this.props;
    const newState = { value: condition, text: '', ...formatOptionsValues(options) };
    const isEqualState = isEqual(newState, this.state);
    if (!isEqualState) this.setState(newState);
  };

  renderDropdownMenu = (isOpened) => {
    const { listOptions, type } = this.props;
    const { value, text } = this.state;
    return (
      <CommonMenu
        type={type}
        isOpened={isOpened}
        currentValue={value}
        options={listOptions}
        onConditionChange={this.handleConditionChange}
        inputValue={text}
        onInputChange={this.handleInputChange}
        onApply={this.handleApply}
      />
    );
  };

  getLabel = () => {
    const { condition, placeholder, options, type, isInvalid } = this.props;
    if (isInvalid || !condition) return placeholder;
    const optionsValues = formatOptionsValues(options);
    const messageKey = getConditionTranslationsBySection(type)[condition];
    return <FormattedMessage id={messageKey} values={optionsValues} />;
  };

  render() {
    const { condition, icon, onSectionRemove, isInitialOpened, isRemovable, isDisabled, isInvalid } = this.props;
    return (
      <UserFilterSectionDropdown
        isInitialOpened={isInitialOpened}
        isDisabled={isDisabled}
        currentValue={condition}
        triggerLabel={this.getLabel()}
        menuRenderer={this.renderDropdownMenu}
        isRemovable={isRemovable}
        onRemove={onSectionRemove}
        triggerIcon={icon}
        onClose={this.resetData}
        isInvalid={isInvalid}
      />
    );
  }
}

CommonSection.propTypes = {
  type: T.oneOf(['FarmExternalLinkId', 'FarmFederalPremiseId', 'FarmLocation']).isRequired,
  condition: T.string.isRequired,
  icon: T.string.isRequired,
  listOptions: T.array.isRequired,
  isInvalid: T.bool,
  options: T.array,
  onOptionSelect: T.func,
  onSectionRemove: T.func,
  isRemovable: T.bool,
  isDisabled: T.bool,
  isInitialOpened: T.bool,
  placeholder: T.oneOfType([T.node, T.string]),
};

CommonSection.defaultProps = {
  options: [],
};

export default CommonSection;
